let contain = $(".accordion-read-more");

$(".accordion-read-more .inner-less").each(function () {
  for (let i in this.childNodes) {
    if (this.childNodes[i].data && this.childNodes[i].data.match(/^\s*$/)) {
      this.childNodes[i].remove();
    }
  }
  if (
    this.childNodes[this.childNodes.length - 1].nodeName.toLowerCase() == "br"
  ) {
    this.childNodes[this.childNodes.length - 1].remove();
  }
});
contain.on("click", "[data-action]", function (e) {
  e.preventDefault();
  let action = $(this).data("action");
  if (action === "more") {
    contain.addClass("open");
  } else if (action === "less") {
    contain.removeClass("open");
  }
});

let heroReadMore = $(".hero-read-more");

$(".hero-read-more .inner-less").each(function () {
  for (let i in this.childNodes) {
    if (this.childNodes[i].data && this.childNodes[i].data.match(/^\s*$/)) {
      this.childNodes[i].remove();
    }
  }
  if (
    this.childNodes[this.childNodes.length - 1].nodeName.toLowerCase() == "br"
  ) {
    this.childNodes[this.childNodes.length - 1].remove();
  }
});
heroReadMore.on("click", "[data-action]", function (e) {
  e.preventDefault();
  let action = $(this).data("action");
  if (action === "more") {
    heroReadMore.addClass("open");
  } else if (action === "less") {
    heroReadMore.removeClass("open");
  }
});
